import React from "react";
import { Box, Typography, Button } from "@mui/material";

const AuthSwitchPrompt = ({
  requestType,
  onToggle,
  disabled = false,
  sx = {},
}) => {
  const isLogin = requestType === "login";

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 400,
        mx: "auto",
        mt: 2,
        textAlign: "center",
        ...sx,
      }}
    >
      <Typography
        component='div'
        variant='body2'
        color='text.secondary'
        sx={{ lineHeight: 1.6 }}
      >
        {isLogin ? "Don't have an account? " : "Already have an account? "}

        <Button
          type='button'
          variant='text'
          color='primary'
          onClick={onToggle}
          disabled={disabled}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            p: 0,
            minWidth: 0,
            minHeight: 0,
            verticalAlign: "baseline",
            fontSize: "inherit",
            lineHeight: "inherit",
            display: "inline",
            "&:hover": {
              backgroundColor: "transparent",
              textDecoration: "underline",
            },
          }}
        >
          {isLogin ? "Create an account" : "Sign in"}
        </Button>
      </Typography>
    </Box>
  );
};

export default AuthSwitchPrompt;
